import SearchIcon from '@mui/icons-material/Search'
import { Button, InputAdornment, Stack, TextField } from '@mui/material'
import NotificationSys from 'components/NotificationSystem'
import { MIN_SEARCH_VALUE_LENGTH } from 'const'
import { ChangeEvent, KeyboardEvent, useState } from 'react'
import { OrganizationSearchDrawer } from '../OrganizationSearchDrawer/OrganizationSearchDrawer'

export function OrganizationFooter() {
  const [searchInput, setSearchInput] = useState('')
  const [isSearchDrawerOpen, setIsSearchDrawerOpen] = useState(false)

  const handleSearch = () => {
    if (searchInput.trim().length < MIN_SEARCH_VALUE_LENGTH) {
      NotificationSys.showWarning('Please enter 3 symbols or more to be able to search.')
      return
    }

    setIsSearchDrawerOpen(true)
  }

  const handleCloseSearchDrawer = () => {
    setIsSearchDrawerOpen(false)
  }

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value)
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      handleSearch()
    }
  }

  const flexGrow = { xs: 1, md: 0 }

  return (
    <>
      <Stack spacing={2} direction="row" alignItems="center" sx={{ flexGrow }}>
        <TextField
          size="small"
          placeholder="Enter search terms…"
          value={searchInput}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ flexGrow }}
        />

        <Button variant="contained" onClick={handleSearch}>
          Search Tips
        </Button>
      </Stack>

      <OrganizationSearchDrawer
        isOpen={isSearchDrawerOpen}
        searchQuery={searchInput}
        handleClose={handleCloseSearchDrawer}
      />
    </>
  )
}
